import {
  Layout,
  Button,
  Input,
  message,
  Table,
  ConfigProvider,
  Tabs,
  Row,
  Col,
  Popconfirm,
  Statistic,
  Pagination,
  Tooltip,
  Popover,
} from 'antd'

import { Content } from 'antd/lib/layout/layout'
import zhCN from 'antd/lib/locale/zh_CN'
import OAMSider from '../oam-sider'
import React, { useEffect, useRef, useState } from 'react'
import { sendHttpPostRequest } from '../../../api/http-request'
import Cookies from 'js-cookie'
import GlobalCss from '@/global.module.less'
import idataCourseTableStyles from '../../common/global-styles/idatacoding.module.less'
import { useHistory } from 'react-router-dom'
import { BACKEND_API_URL } from '@/constants/constants'
import UserCard from '../user/oam-userinfo-card'

const { Search } = Input



export interface Props {}
const typeMap = new Map([
  [1, '实训'],
  [6, '纯讲义'],
])
const difficultyMap = new Map([
  [1, '容易'],
  [2, '中等'],
  [3, '困难'],
])

export const OAMTaskList: React.FC<Props> = (props) => {
  const [exerciseResult, setExerciseResult] = useState([] as any[]) // 当前显示的结果页
  const [resultSum, setResultSum] = useState(0) // 搜索返回的结果数
  const [totalCount, setTotalCount] = useState(0) // 搜索返回的结果数
  const queryContent = useRef('') // 记录搜索串
  const querySource = useRef('2') // 来源 1-个人  2-OAM创建（系统）
  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(10) // 记录当前每页展示数量
  const userIsLogin = useRef(false) // 用户是否登录
  const typeFilters = useRef([]) // 类型过滤选项
  const difficultyFilters = useRef([]) // 难易程度过滤选项
  const createTime = useRef('') // 创建时间
  const history = useHistory()

  const [sysCount, setSysCount] = useState(0) //搜索返回的结果数
  const [userCount, setUserCount] = useState(0) //搜索返回的结果数
  const [onlineCount, setOnlineCount] = useState(0) //搜索返回的结果数

  useEffect(() => {
    queryExerciseList()
  }, [])

  /**
   * 查询任务列表
   */
  function queryExerciseList() {
    sendHttpPostRequest(
      'exercise/api/oam_query_exercise_list/',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),

        query_type: 1,
        query: queryContent.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: order_by.current,
        type: JSON.stringify(typeFilters.current),
        difficulty: JSON.stringify(difficultyFilters.current),
        create_time: createTime.current,
        source: querySource.current,
      },
      queryExerciseListCallback
    )
  }

  /**
   * 查询任务列表回调
   * @param response
   */
  const queryExerciseListCallback = (response: any) => {
    // console.log(response)
    message.destroy()
    if (response.code == -100) {
      // 未登录
      window.location.href = '/oam_login?next=oam_task'
    } else if (response.code == 0) {
      // 成功
      setExerciseResult(response.exercise_list)
      setResultSum(response.total_sum)
      setTotalCount(response.total_count)
      setSysCount(response.sys_count)
      setUserCount(response.user_count)
      setOnlineCount(response.online_count)
    } else if (response.code == -501) {
      // 权限不足
      window.location.href = '/oam_login?next=oam_task'
    } else {
      message.error(response.message)
    }
  }


  /**
   * 点击创建任务
   */
  const createTask = () => {
    history.push('/oam_task_create')
  }

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryExerciseList()
  }

  // 渲染类型
  const renderType = (text: any, record: any) => (
    <div>{typeMap.get(parseInt(text))}</div>
  )

  // 渲染难易程度
  const renderDifficulty = (text: any, record: any) => (
    <div>{difficultyMap.get(parseInt(text))}</div>
  )

  // 删除回调
  const onDeleteBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == 100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_task'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_task'
    } else if (response.is_ok == true) {
      message.success('删除任务成功~')
      queryExerciseList()
    } else {
      message.error(response.message)
    }
  }

  // 点击 删除
  const onDeleteBtnClick = (taskId: string) => {
    sendHttpPostRequest(
      'exercise/api/oam_delete_task/',
      {
        sessionid: Cookies.get('sessionid'),
        exercise_id: taskId,
      },
      onDeleteBtnClickCallback
    )
  }

  // 上下架回调
  const onPutOnOffBtnClickCallback = (response: any) => {
    message.destroy()
    if (response.code == 100) {
      // 没登录
      window.location.href = '/oam_login?next=oam_task'
    } else if (response.code == -501) {
      // 没权限
      window.location.href = '/oam_login?next=oam_task'
    } else if (response.code == 0) {
      message.success(response.message)
      queryExerciseList()
    } else {
      message.error(response.message)
    }
  }

  // 点了上下架按钮
  const onPutOnOffBtnClick = (exerciseId: string, statusStr: string) => {
    sendHttpPostRequest(
      'exercise/api/oam_update_task_status/',
      {
        sessionid: Cookies.get('sessionid'),
        exercise_id: exerciseId,
      },
      onPutOnOffBtnClickCallback
    )
  }

  // 点了预览按钮
  const onLookOverBtnClick = (exerciseId: string, event: any) => {
    window.open(`/oam_preview_task?task_id=${exerciseId}`)
  }

  // 渲染操作
  const renderActions = (text: any, record: any) => {
    if (record.source == 2) {
      return (
        <Row align="middle" gutter={[8, 4]} justify={'center'} wrap={false}>
          <Col style={{ width: 50 }}>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="lookover"
              value={record.id}
              type="default"
              onClick={onLookOverBtnClick.bind(this, record.id)}
            >
              {' '}
              测 试{' '}
            </Button>
          </Col>
          <Col style={{ width: 50 }}>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="editit"
              type="dashed"
              onClick={onEditBtnClick.bind(this, record.id)}
            >
              {' '}
              编辑
            </Button>
          </Col>
          <Col style={{ width: 50 }}>
            {' '}
            {parseInt(record.status) == 1 ? (
              <Button
                style={{ borderRadius: 20, fontSize: 12 }}
                size="small"
                id="puton"
                value={record.id}
                type="primary"
                onClick={onPutOnOffBtnClick.bind(
                  this,
                  record.id,
                  record.status
                )}
              >
                {' '}
                上 架{' '}
              </Button>
            ) : (
              <Popconfirm
                placement="top"
                title={'确认下架任务"' + record.title + '"吗？'}
                onConfirm={onPutOnOffBtnClick.bind(
                  this,
                  record.id,
                  record.status
                )}
                okText="确认"
                cancelText="取消"
              >
                <Button
                  style={{ borderRadius: 20, fontSize: 12 }}
                  size="small"
                  id="putoff"
                  value={record.id}
                  type="primary"
                  danger
                >
                  {' '}
                  下 架{' '}
                </Button>
              </Popconfirm>
            )}
          </Col>

          {parseInt(record.status) == 1 ? (
            <Col style={{ width: 50 }}>
              <Popconfirm
                placement="top"
                title={'确认删除任务"' + record.title + '"吗？'}
                onConfirm={onDeleteBtnClick.bind(this, record.id)}
                okText="确认"
                cancelText="取消"
              >
                <Button
                  style={{ borderRadius: 20, fontSize: 14 }}
                  size="small"
                  id="deleteexe"
                  type="dashed"
                  danger
                >
                  {' '}
                  删除
                </Button>
              </Popconfirm>
            </Col>
          ) : (
            ''
          )}
        </Row>
      )
    } else {
      return (
        <Row justify="center" align="middle" gutter={[8, 4]}>
          <Col span={24}>
            <Button
              style={{ borderRadius: 20, fontSize: 14 }}
              size="small"
              id="lookover"
              value={record.id}
              type="default"
              onClick={onLookOverBtnClick.bind(this, record.id)}
            >
              {' '}
              预 览{' '}
            </Button>
          </Col>
        </Row>
      )
    }
  }

  //点击了编辑按钮
  const onEditBtnClick = (id: any, event: any) => {
    window.open('/oam_task_edit?task_id=' + id)
  }

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryExerciseList()
  }

  // 切换Tab页
  const onTabKeyChange = (key: string) => {
    console.log(key)
    querySource.current = key
    page.current = 1
    queryExerciseList()
  }

  // 表格发生变化
  const onTableChange: any = (
    pagination: any,
    filters: any,
    sorter: any,
    extra: { currentDataSource: []; action: any }
  ) => {
    if (sorter.order) {
      //如果选择了排序列
      order.current = sorter.order
      order_by.current = sorter.field
    }
    if (filters.type) {
      //如果选择了过滤列
      typeFilters.current = filters.type
    } else {
      typeFilters.current = []
    }
    if (filters.difficulty) {
      difficultyFilters.current = filters.difficulty
    } else {
      difficultyFilters.current = []
    }
    page.current = 1
    queryExerciseList()
  }

  const columns: any = [
    {
      title: '序号',
      dataIndex: 'id',
      key: 'id',
      align: 'left',
      ellipsis: true,
      width: 50,
    },
    {
      title: '任务名称',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true,
      align: 'left',
      width: 100,
    },
    {
      title: '备注',
      dataIndex: 'remarks',
      key: 'remarks',
      align: 'center',
      width: 100,
      ellipsis: true,
    },
    {
      title: '任务类型',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      width: 80,
      render: renderType,
      filters: [
        {
          text: '实训',
          value: 1,
        },

        {
          text: '纯讲义',
          value: 6,
        },
      ],
      onFilter: (value: any, record: any) => true,
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      width: 150,
      align: 'left',
      render: (text, record) => {
        return (
          <Row align="middle" wrap={false}>
            <Col flex="40px">
              <Popover
                arrowPointAtCenter={true}
                trigger="hover"
                placement="left"
                content={<UserCard user_id={record?.creator_id} />}
                title={null}
              >
                <img
                  onMouseOver={() => {}}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    cursor: 'pointer',
                  }}
                  src={
                    record?.creator_avatar?.startsWith('http')
                      ? record?.creator_avatar
                      : BACKEND_API_URL + record?.creator_avatar
                  }
                />
              </Popover>{' '}
            </Col>
            <Col flex="auto">
              <span>{text}</span>
            </Col>
          </Row>
        )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'center',
      width: 120,
      sorter: true,
      ellipsis: true,
      sortDirections: ['descend', 'ascend'],
      defaultSortOrder: 'descend',
    },
    {
      title: '操作',
      dataIndex: 'id',
      key: 'actions',
      width: 220,
      ellipsis: false,
      align: 'center',
      fixed: 'right',
      render: renderActions,
    },
  ]

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={['5']} openKeys={[]} />
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30, paddingBottom: 30 }}>
            <div
              id="query-exercise-list-btn"
              hidden={true}
              onClick={queryExerciseList}
            ></div>
            <Row align="middle" gutter={16}>
              <Col flex="80px">
                <Statistic title="总任务" value={totalCount} />
              </Col>
              <Col flex="80px">
                <Statistic title="系统任务" value={sysCount} />
              </Col>
              {/*<Col flex='80px'>*/}
              {/*    <Statistic title="个人任务" value={userCount} />*/}
              {/*</Col>*/}
              <Col flex="80px">
                <Statistic title="已上架" value={onlineCount} />
              </Col>
              <Col flex="250px">
                <Search
                  placeholder="搜索任务"
                  style={{ width: 350 }}
                  enterButton={true}
                  onSearch={onSearchBtn}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: 'right' }}>
                <Button
                  type="primary"
                  style={{ float: 'right', marginRight: 20, borderRadius: 20 }}
                  onClick={createTask}
                >
                  创建任务
                </Button>
              </Col>
            </Row>
            <div style={{height:500}} className={GlobalCss.tableWrapper}>
              <ConfigProvider locale={zhCN}>
                <Table
                  dataSource={exerciseResult}
                  columns={columns}
                  rowKey={(record) => record.id}
                  pagination={false}
                  scroll={{ x: 800 }}
                  //bordered={true}
                  onChange={onTableChange}
                />
              </ConfigProvider>
            </div>

            <ConfigProvider locale={zhCN}>
              <div
                style={{
                  marginBottom: 30,
                  paddingTop: 30,
                  textAlign: 'center',
                }}
                className={'css.pagination'}
              >
                <Pagination
                  defaultCurrent={1}
                  total={resultSum}
                  defaultPageSize={10}
                  hideOnSinglePage={true}
                  current={page.current}
                  onChange={onPageChange}
                  showQuickJumper={true}
                  showTotal={(total) => `共 ${total} 任务`}
                  pageSizeOptions={['10', '20', '50', '100']}
                />
              </div>
            </ConfigProvider>
          </div>
        </Content>
      </Layout>
    </Layout>
  )
}

export default OAMTaskList
